import axios from 'axios'
import qs from 'qs'
import { Message, MessageBox } from 'element-ui'
import decamelize from 'decamelize-keys-deep'
import camelcase from 'camelcase-keys-deep'
import { exportFile } from '@/common/utils'
import { httpConfig } from '@/common/app.config'

const generateApiMap = (map) => {
	let facade = {}
	for (let el in map) {
		facade[el] = toMethod(map[el]);
	}
	return facade
};
// PASSPORT_HOST = 139.129.221.123;
// API_HOST = 139.129.221.123;
// UPLOAD_HOST = 139.129.221.123 ;
//const baseURLs = ['http://shiquaner.zookingsoft.com',];

//const baseURLs = ['http://shiquaner-admin-api.zookingsoft.com',];
//localStorage.setItem("URL","http://shiquaner.zookingsoft.com");

var baseURLs = ['http://dev-api-ndesigner-admin.idatachain.cn'];
localStorage.setItem("URL", "http://dev-shiquaner.idatachain.cn");
localStorage.setItem("adminURL", "http://dev-api-ndesigner-admin.idatachain.cn")

var upload_key = '6iu9AtSJgGSRidOuF9lUQr7cKkW9NGrY'
var file_upload_baseURL = 'http://139.129.221.123/File/File/insert?'+'key='+upload_key //上传地址
var file_baseURL = 'http://139.129.221.123'

//console.log(window.location.host);
// if (window.location.host == 'shiquaner-admin.zookingsoft.com') {
	baseURLs = ['http://shiquaner-admin-api.zookingsoft.com',];
	localStorage.setItem("URL", "http://shiquaner.zookingsoft.com")
	localStorage.setItem("adminURL", "http://shiquaner-admin-api.zookingsoft.com");
	file_upload_baseURL='https://shiquaner-api.zookingsoft.com/File/File/insert?'+'key='+upload_key
	file_baseURL = 'https://shiquaner-api.zookingsoft.com'
// }
// if (window.location.host == '120.27.22.130:8082') {
// 	baseURLs = ['http://120.27.22.130:8083',];
// 	localStorage.setItem("URL", "http://120.27.22.130:8080")
// 	localStorage.setItem("adminURL", "http://120.27.22.130:8083");
// 	file_upload_baseURL='http://139.129.221.123/File/File/insert?'+'key='+upload_key
// 	file_baseURL = 'http://139.129.221.123'
// }
window.upload_key = upload_key
window.file_upload_baseURL = file_upload_baseURL
window.file_baseURL = file_baseURL
console.log(window.file_upload_baseURL,'window.file_upload_baseURL')
localStorage.setItem("baseURLs", baseURLs + '/Admin');
const toMethod = (options) => {
	options.method = options.method || 'post'
	return (params = {}, attachedParams, config = {}) => {
		config.varConversion = options.varConversion
		config.isExport = options.isExport
		config.showExportTipsAlert = options.showExportTipsAlert === undefined ? true : options.showExportTipsAlert
		return sendApiInstance(options.method, options.url, params, config, options.isType, options.baseURL, options.Type)
	}
}
// 创建axios实例
const createApiInstance = (config = {}, on, Type) => {
	let ds = on ? on : 0;
	const _config = {
		withCredentials: true, // 跨域
		baseURL: baseURLs[ds],
		headers: {
			//'Authorization':'Bearer '+localStorage.getItem('token'),
			'Content-Type': Type ? Type : 'application/x-www-form-urlencoded',
			// 'Content-Type': 'application/zip'
		},
	}
	config = Object.assign(_config, config);

	return axios.create(config)
}
const sendApiInstance = async (method, url, params, config = {}, isType = {}, on, Type) => {
	if (config.varConversion) {
		params = decamelize(params)
	}

	let rawParams = params = Object.assign({ access_token: localStorage.getItem('access_token') }, params)

	// 定义启用isExport 且 请求参数启用了is_export = 1，将使用导出功能
	if (config.isExport && params.is_export == 1) {
		if( config.showExportTipsAlert ) {
			await MessageBox.alert('确定导出表格数据?', '导出数据', {
				showCancelButton: true,
				cancelButtonText: '取消',
				confirmButtonText: '确定'
			});
		}

		exportFile(JSON.parse(JSON.stringify(params)), httpConfig.host + url)
		return
	}

	if (method === 'post') {
		params = qs.stringify(params);
	}
	if (!url) { return }
	let instance = createApiInstance(config, on, Type)
	instance.interceptors.response.use(response => {
		let { result, msg, data } = response.data;
		if (result == 0) {
			if(rawParams.operation){
				Message({ message: '操作成功', type: 'success', duration: 2000 ,offset:65});
			}
			if (isType.suktip) {
				Message({ message: '操作成功', type: 'success', duration: 2000 ,offset:65});
			}

			if (isType.reload) {
				location.reload();
			}

			if (config.varConversion) {
				data = camelcase(data)
			}

			if (isType.isok) {
				return response.data
			} else {
				return data
			}


		} else if (result == 201) {
			localStorage.setItem("access_token", '');
			window.location.href = data;
		} else {
			if(rawParams.$show_error === undefined || rawParams.$show_error) {
				Message({ dangerouslyUseHTMLString: true, message: data, type: 'error' });
			}
			
			return Promise.reject(data)
		}
	}, error => {
		if(rawParams.$show_error === undefined || rawParams.$show_error) {
			Message({ message: '服务器故障', type: 'warning' });
		}
		return Promise.reject(error)
	});
	return instance[method](url, params, config)
}
export default {
	generateApiMap
}
